import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-toolbar" }
const _hoisted_2 = { class: "w-toolbar-group" }
const _hoisted_3 = {
  key: 0,
  class: "w-field w-branch-field"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  class: "w-tabs",
  "aria-label": "Календари"
}
const _hoisted_7 = ["aria-pressed"]
const _hoisted_8 = ["aria-pressed"]
const _hoisted_9 = {
  key: 1,
  class: "w-field w-staff-field"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "w-week-nav" }
const _hoisted_13 = { class: "w-week-label" }
const _hoisted_14 = { class: "w-view-row" }
const _hoisted_15 = { class: "w-view-fields" }
const _hoisted_16 = { class: "w-field w-date-field" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "w-small w-hours-range" }
const _hoisted_19 = { class: "w-actions" }
const _hoisted_20 = ["disabled"]

import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import { formatDate } from '~utils/calendarModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarToolbar',
  setup(__props) {

const store = useScheduleStore();

const hasOwnCalendar = computed(() => store.editableStaffIds.includes(Number(store.actorStaffId)));
const hasTeam = computed(() => store.editableStaffIds.length > 1);

// «5–11 октября 2026», на стыке месяцев — «26 октября–1 ноября 2026»
const weekLabel = computed(() => {
  const first = store.weekDays[0];
  const last = store.weekDays[store.weekDays.length - 1];
  const sameMonth = first.slice(0, 7) === last.slice(0, 7);
  const firstText = formatDate(first, sameMonth ? { day: 'numeric' } : { day: 'numeric', month: 'long' });
  const lastText = formatDate(last, { day: 'numeric', month: 'long', year: 'numeric' });
  return `${firstText}–${lastText.replace(' г.', '')}`;
});

const hoursRange = computed(() => {
  const { from, to } = store.viewHours;
  return from ? `Весь рабочий день · ${from}–${to}` : 'В выбранные даты филиал закрыт';
});

const onStaffChange = (event: Event) => {
  store.setStaff(Number((event.target as HTMLSelectElement).value));
};

const onBranchChange = (event: Event) => {
  store.setBranch(Number((event.target as HTMLSelectElement).value));
};

const onDateChange = (event: Event) => {
  store.setDate((event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(store).branchOptions.length > 1)
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "w-small" }, "Филиал", -1)),
              _createElementVNode("select", {
                value: _unref(store).branchId,
                onChange: onBranchChange
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).branchOptions, (branch) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: branch.id,
                    value: branch.id
                  }, _toDisplayString(branch.name), 9, _hoisted_5))
                }), 128))
              ], 40, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (hasOwnCalendar.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                "aria-pressed": String(_unref(store).mode === 'mine'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).setMode('mine')))
              }, " Мой календарь ", 8, _hoisted_7))
            : _createCommentVNode("", true),
          (hasTeam.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                "aria-pressed": String(_unref(store).mode === 'team'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).setMode('team')))
              }, " Команда ", 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        (hasTeam.value && _unref(store).mode === 'team')
          ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "w-small" }, "Календарь сотрудника", -1)),
              _createElementVNode("select", {
                value: _unref(store).staffId,
                onChange: onStaffChange
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).editableDoctors, (doctor) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: doctor.id,
                    value: doctor.id
                  }, _toDisplayString(doctor.name), 9, _hoisted_11))
                }), 128))
              ], 40, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "w-button w-icon",
          type: "button",
          "aria-label": "Предыдущая неделя",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).shiftWeek(-1)))
        }, [
          _createVNode(_component_q_icon, { name: "chevron_left" })
        ]),
        _createElementVNode("span", _hoisted_13, _toDisplayString(weekLabel.value), 1),
        _createElementVNode("button", {
          class: "w-button w-icon",
          type: "button",
          "aria-label": "Следующая неделя",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).shiftWeek(1)))
        }, [
          _createVNode(_component_q_icon, { name: "chevron_right" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", _hoisted_16, [
          _cache[8] || (_cache[8] = _createTextVNode(" Дата ", -1)),
          _createElementVNode("input", {
            type: "date",
            value: _unref(store).date,
            onChange: onDateChange
          }, null, 40, _hoisted_17)
        ]),
        _createElementVNode("span", _hoisted_18, _toDisplayString(hoursRange.value), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "w-button",
          type: "button",
          disabled: !_unref(store).canPlan,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).selectRange(_unref(store).date, '13:00', '14:00')))
        }, [
          _createVNode(_component_q_icon, { name: "touch_app" }),
          _cache[9] || (_cache[9] = _createTextVNode(" Выбрать интервал ", -1))
        ], 8, _hoisted_20),
        _createElementVNode("button", {
          class: "w-button",
          type: "button",
          "data-action": "refresh",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(store).loadSnapshot()))
        }, [
          _createVNode(_component_q_icon, { name: "refresh" }),
          _cache[10] || (_cache[10] = _createTextVNode(" Обновить ", -1))
        ])
      ])
    ])
  ], 64))
}
}

})